import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CreateExpedition from '@app/pages/expedition/create/CreateExpedition.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { useSearchParams } from 'react-router-dom';

interface ComponentProps {
}

const CreateExpeditionPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  const [searchParams] = useSearchParams();

  const idsFromQuery = (name: string) =>
    (searchParams.get(name) || '')
      .split(',')
      .map(id => id.trim())
      .filter(id => id.length > 0);

  // Arriving from a list's merge action: the entities to fold into this one. A merge may be started
  // from either list, and the backend accepts both kinds in the same request.
  const mergeExpeditionIds = idsFromQuery('mergeExpeditionIds');
  const mergeSupplierNotificationIds = idsFromQuery('mergeSupplierNotificationIds');
  // Arriving from a route optimization on the notification list: the group itself is in session storage.
  const consolidationRequestId = searchParams.get('consolidationRequestId') || undefined;
  const consolidationGroupId = searchParams.get('consolidationGroupId') ? Number(searchParams.get('consolidationGroupId')) : undefined;

  return (
    <>
      <ResponsiveLayout title={tr('create.vytvoreniExpedice', 'Vytvoření expedice')}
                        oneOfPermission={[
                          PermissionTypesEnum.PERMISSION_EXPEDITION_CREATE,
                        ]}
      >
        <CreateExpedition
          mergeExpeditionIds={mergeExpeditionIds}
          mergeSupplierNotificationIds={mergeSupplierNotificationIds}
          consolidationRequestId={consolidationRequestId}
          consolidationGroupId={consolidationGroupId}
        />
      </ResponsiveLayout>
    </>);

};

export default withAuthenticationRequired(CreateExpeditionPage);